import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { FormateDate } from "../utils/FormateDate";
import { Link as NavLink } from "react-router-dom";

const RootStyle = styled(Card)({
  padding: "5% 2%",
  background: "#27B1BB",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  fontFamily: "Inter",
  //width: "198px",
  height: "190px",
  // minHeight: "200px",
});
const DateBox = styled(Box)({
  background: "#EBEBEB",
  borderRadius: "10px",
  height: "38px",
  width: "90%",
  margin: "0 auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

function ExamCard({ exam }) {
  return (
    <RootStyle>
      <NavLink
        // to={`/${exam.ExamVendorName}/${exam.ExamCode}`}
        // to={`${exam.ExamVendorName.toLowerCase()}/${exam.ExamCode.toLowerCase()}`}
        to={`/${encodeURIComponent(exam.ExamVendorName.replace(/ /g, "-"))
          .toLowerCase()
          .replace(/%2b/g, "p")}/${exam.ExamCode.toLowerCase()}`}
        state={exam}
        style={{
          textDecoration: "none",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: { xs: "12px", sm: "12px", md: "15px" },
            fontFamily: "Inter",
            fontWeight: 700,
            color: "white",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {exam?.ExamCode}
        </Typography>
      </NavLink>
      <NavLink
        // to={`${exam.ExamVendorName.toLowerCase()}/${exam.ExamCode.toLowerCase()}`}
        to={`/${encodeURIComponent(exam.ExamVendorName.replace(/ /g, "-"))
          .toLowerCase()
          .replace(/%2b/g, "p")}/${exam.ExamCode.toLowerCase()}`}
        state={exam}
        style={{ textDecoration: "none" }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: { xs: "10px", sm: "10px", md: "13px" },
            color: "#FFFFFF",
            px: 2,
            //width: "140px",
            fontFamily: "Inter",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {exam?.ExamName}
        </Typography>
      </NavLink>
      <DateBox>
        <Typography
          sx={{
            fontSize: { xs: "8px", md: "10px", lg: "10px" },
            textAlign: "center",
            fontFamily: "Inter",
            fontWeight: "500",
          }}
        >
          {FormateDate(exam.Date)}
        </Typography>
      </DateBox>
    </RootStyle>
  );
}

export default ExamCard;
